<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>设备列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box" :style="heightToolsBar">
        <div class="list-box">
          <div class="l-list" v-show="!disabled">
            <el-button-group>
              <el-button
                type="primary"
                v-if="flagAdd"
                icon="el-icon-plus"
                @click="addLinkUrl"
                >新增</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>

              <el-select v-model="modelId" placeholder="请选择型号...">
                <el-option :key="0" label="全部型号" :value="0"></el-option>
                <el-option
                  v-for="item in cabinetModelList"
                  :key="item.id"
                  :label="item.modelName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-box">
              <el-input placeholder="输入设备编号，关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initData"
                ></el-button>
              </el-input>
            </div>
            <div class="btn-box" v-show="false">
              <el-button-group>
                <el-button
                  type="primary"
                  :icon="iconToolsBar"
                  @click="toggleToolsBar"
                ></el-button>
              </el-button-group>
            </div>
            <div class="search-box">
              <el-button
                type="primary"
                @click="toggleChage"
                style="float: right"
                >切换监控</el-button
              >
            </div>
          </div>
        </div>
        <div class="more-box">
          <dl>
            <dt>筛选型号</dt>
            <dd></dd>
          </dl>
          <dl v-show="false">
            <dt>状态</dt>
            <dd>
              <el-select v-model="status" placeholder="请选择">
                <el-option label="全部状态" :value="-1"></el-option>
                <el-option label="空闲" :value="0"></el-option>
                <el-option label="充电" :value="1"></el-option>
                <el-option label="放电" :value="2"></el-option>
                <el-option label="维护" :value="3"></el-option>
                <el-option label="故障" :value="4"></el-option>
              </el-select>
            </dd>
          </dl>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column
              prop="modelName"
              label="设备型号"
              width="80"
            ></el-table-column>
            <el-table-column label="设备编号" width="80">
              <template slot-scope="scope">
                {{ scope.row.cabinetCode }}
              </template>
            </el-table-column>
            <el-table-column
              prop="cabinetName"
              label="设备标签"
            ></el-table-column>
            <el-table-column label="网络" min-width="60" align="center">
              <template slot-scope="scope">
                <el-tag
                  size="small"
                  type="success"
                  effect="dark"
                  v-if="scope.row.online == 1"
                  >在线</el-tag
                >
                <el-tag
                  size="small"
                  type="info"
                  effect="dark"
                  v-else
                  :title="`离线时间: ${
                    scope.row.offlineTime ? scope.row.offlineTime : '未知'
                  }`"
                  >未知</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              width="64"
              prop="temp"
              label="温度℃"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="soc"
              label="电量SOC"
              width="80"
            ></el-table-column>

            <el-table-column label="状态" min-width="60" align="center">
              <template slot-scope="scope">
                <el-tag
                  size="small"
                  type="info"
                  effect="dark"
                  v-if="scope.row.state == 1"
                  >待机</el-tag
                >
                <el-tag
                  size="small"
                  type="warning"
                  effect="dark"
                  v-else-if="scope.row.state == 3"
                  >故障
                </el-tag>
                <el-tag
                  size="small"
                  type="warning"
                  effect="dark"
                  v-else-if="scope.row.state == 4"
                  >充电
                </el-tag>
                <el-tag
                  size="small"
                  type="warning"
                  effect="dark"
                  v-else-if="scope.row.state == 5"
                  >放电
                </el-tag>
                <el-tag size="small" type="success" v-else>空闲</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="iotCardNo"
              label="物联卡号"
            ></el-table-column>
            <el-table-column
              prop="softVer"
              label="软件版本"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="feeName"
              label="费率"
            ></el-table-column>
            <el-table-column
              prop="gmtModified"
              label="更新时间"
            ></el-table-column>
            <el-table-column
              prop="gmtCreate"
              label="添加时间"
            ></el-table-column>

            <el-table-column
              fixed="right"
              align="center"
              label="操作"
              width="170"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  title="大屏"
                  icon="el-icon-view"
                  v-if="flagLook"
                  @click="cabinetShow(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="指令"
                  icon="el-icon-finished"
                  v-if="false"
                  @click="deliveryDialogOpen(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="编辑"
                  icon="el-icon-edit"
                  v-if="flagUpdate"
                  @click="linkUrl(scope.row.id)"
                ></el-button>
                <el-button
                  size="mini"
                  title="删除"
                  type="danger"
                  icon="el-icon-delete"
                  v-if="flagDel"
                  @click="deleteItem(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>

      <el-dialog
        title=""
        :visible.sync="showDeliveryDialog"
        style="text-align: left"
      >
        <div class="content-box side">
          <el-card shadow="hover">
            <div slot="header" class="clearfix">
              <i class="iconfont icon-setting-full"></i>
              <span>操作设备 </span>
            </div>
            <el-form label-width="100px">
              <el-form-item label="设备编号">
                <b>{{ cabinetCode }}</b>
              </el-form-item>

              <el-form-item label="设备状态" v-if="flagWorkStateControl">
                <el-select
                  placeholder="请选择..."
                  v-model="workStateControl.state"
                  style="width: 120px"
                >
                  <el-option
                    v-for="item in stateList"
                    :key="item.id"
                    :label="item.Name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="setWorkState"
                  >下发</el-button
                >
              </el-form-item>

              <el-form-item
                label="设备密码"
                v-if="flagSetPasswd || flagViewPasswd"
              >
                <el-select
                  placeholder="请选择..."
                  v-model="cabinetPasswd.userType"
                  style="width: 120px"
                >
                  <el-option
                    v-for="item in userTypeList"
                    :key="item.userType"
                    :label="item.Name"
                    :value="item.userType"
                  >
                  </el-option>
                </el-select>
                <el-button
                  plain
                  icon="el-icon-view"
                  @click="showPasswd"
                  v-if="flagViewPasswd"
                  >指令查询</el-button
                >
                <span class="interval-box">
                  {{ cabinetPasswd.oldPasswd }}
                </span>
                <el-input
                  v-model="cabinetPasswd.newPasswd"
                  style="width: 150px"
                  placeholder="8位数字密码"
                  v-if="flagSetPasswd"
                >
                </el-input>
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="setPasswd"
                  v-if="flagSetPasswd"
                  >下发</el-button
                >
              </el-form-item>

              <el-form-item label="设备费率">
                <el-button
                  plain
                  icon="el-icon-view"
                  @click="showFeeConfig"
                  v-if="flagViewFeeConfig"
                  >指令查询</el-button
                >
                <span class="interval-box"></span>
                <el-select
                  placeholder="请选择..."
                  v-model="delivery.feeConfigId"
                  style="width: 150px; margin-right: 35px"
                  v-if="flagSetFeeConfig"
                >
                  <el-option
                    v-for="item in FeeConfigList"
                    :key="item.id"
                    :label="item.feeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>

                <div v-if="false">
                  生效时间：
                  <el-date-picker
                    style="width: 180px"
                    v-model="delivery.effectiveTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    placeholder="生效时间"
                  >
                  </el-date-picker>
                </div>

                <div v-if="false">
                  尖峰月：
                  <el-input
                    style="width: 100px"
                    v-model="delivery.topPeakMonths"
                    placeholder="6,7,8"
                  ></el-input>
                </div>

                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="setFeeConfig"
                  v-if="flagSetFeeConfig"
                  >下发</el-button
                >
              </el-form-item>

              <!-- <el-form-item label="软件升级">
                <el-input
                  v-model="cabinetUpdate.softVer"
                  style="width: 150px; margin-right: 38px"
                  placeholder="版本号,如：1.002"
                >
                </el-input>

                <div v-if="false">
                  下载地址：
                  <el-input
                    v-model="cabinetUpdate.downUrl"
                    style="width: 442px"
                    placeholder="完整URL http://..."
                  />
                </div>
                <el-button type="primary" icon="el-icon-edit" @click="setUpdate"
                  >下发</el-button
                >
              </el-form-item> -->
            </el-form>

            <el-row class="card-form" v-show="showFee">
              <el-col :xs="24" :sm="12">
                <el-card shadow="hover">
                  <div slot="header" class="clearfix">
                    <span>时段/充电最大功率</span>
                  </div>

                  <div class="dl-box">
                    <ul>
                      <li
                        style="margin-bottom: 12px"
                        v-for="(fee, index) in feeModel.periodFeeConfigs"
                        :key="index"
                      >
                        {{ fee.startTime }}
                        <span style="margin: 0 10px 22px">至</span>
                        {{ fee.endTime }}
                        <span style="margin: 0 10px 22px"></span>

                        <span v-if="fee.controlMode == 1">充电</span>
                        <span v-else-if="fee.controlMode == 2">放电</span>
                        <span v-else="fee.controlMode == 3">空闲</span>

                        <span v-if="fee.periodType == 1">尖</span>
                        <span v-else-if="fee.periodType == 2">峰</span>
                        <span v-else-if="fee.periodType == 3">平</span>
                        <span v-else-if="fee.periodType == 4">谷</span>
                        <span v-else="fee.periodType == 5">高尖</span>

                        <span style="margin-left: 10px">{{
                          fee.maxPower
                        }}</span>
                        <span>kW</span>
                      </li>
                    </ul>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-card shadow="hover">
                  <div slot="header" class="clearfix">
                    <span>费用</span>
                  </div>
                  <div class="dl-box-fee">
                    <div>尖时:{{ feeModel.fee1 }} 元</div>

                    <div>峰时:{{ feeModel.fee2 }} 元</div>

                    <div>平时:{{ feeModel.fee3 }} 元</div>

                    <div>谷时:{{ feeModel.fee4 }} 元</div>

                    <div>高尖时:{{ feeModel.fee5 }} 元</div>
                  </div>
                </el-card>
                <el-card shadow="hover" style="margin: 20px 0px 0px 0px">
                  <div slot="header" class="clearfix">
                    <span>其他</span>
                  </div>

                  <div class="dl-box">
                    <ul>
                      <li style="margin-bottom: 12px">
                        生效时间： <span style="margin: 0 10px 22px"></span>
                        {{ feeModel.effectiveTime }}
                      </li>

                      <li style="margin-bottom: 12px; display: none">
                        尖峰月： <span style="margin: 0 10px 22px"></span>
                        <span
                          v-for="(mon, index) in feeModel.topPeakMonths"
                          style="margin: 0 10px 0px 0px"
                          :key="index"
                          >{{ mon }}</span
                        >
                      </li>
                    </ul>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  AxiosAjax,
  getModelData,
  getCompanyData,
  GetQueryValue,
} from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      cabinetCode: "", //当前选的设备
      disabled: false,
      companyId: "",
      status: "",
      dateRange: [],
      showDeliveryDialog: false, //发指令窗口
      loading: false,
      showFee: false, //显示查询结果
      modelId: "",
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      companyList: [],
      companySouList: [],
      cabinetModelList: [],
      showToolsBar: false, //显示更多条件选项
      heightToolsBar: "height:60px", //工具栏高度
      iconToolsBar: "iconfont icon-d-arrow-down", //更多按钮图标
      FeeConfigList: [],
      stateList: [
        {
          Name: "停机",
          id: 2,
        },
        {
          Name: "运行",
          id: 6,
        },
      ],
      userTypeList: [
        {
          Name: "技术员",
          userType: "admin",
        },
        {
          Name: "运营商",
          userType: "customer",
        },
      ],
      delivery: {
        effectiveTime: "",
        topPeakMonths: "",
        feeConfigId: "",
      },
      cabinetPasswd: {
        userType: "customer",
        cabinetCode: "",
        newPasswd: "",
        oldPasswd: "******",
      },
      cabinetUpdate: {
        cabinetCode: "",
        softVer: "",
        downUrl: "",
        force: "",
        md5: "",
      },
      workStateControl: {
        cabinetCode: "",
        state: "",
      },
      feeModel: {
        effectiveTime: "",
        fee1: 0,
        fee2: 0,
        fee3: 0,
        fee4: 0,
        fee5: 0,
        periodFeeConfigs: [
          {
            controlMode: 0,
            endTime: "",
            periodType: 0,
            startTime: "",
          },
        ],
        topPeakMonths: [],
      },
      flagAdd: false,
      flagDel: false,
      flagLook: false,
      flagUpdate: false,
      flagInstruct: false,
      flagSetFeeConfig: false,
      flagViewFeeConfig: false,
      flagViewPasswd: false,
      flagSetPasswd: false,
      flagWorkStateControl: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "监控中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "设备管理");
        console.log(obj1);

        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
          if (element.name == "ViewFeeConfig") {
            this.flagViewFeeConfig = element.selected;
          }
          if (element.name == "SetFeeConfig") {
            this.flagSetFeeConfig = element.selected;
          }
          if (element.name == "WorkStateControl") {
            this.flagWorkStateControl = element.selected;
          }
          if (element.name == "ViewPasswd") {
            this.flagViewPasswd = element.selected;
          }
          if (element.name == "SetPasswd") {
            this.flagSetPasswd = element.selected;
          }
        });
        let arr = [
          "ViewFeeConfig",
          "WorkStateControl",
          "SetFeeConfig",
          "SetPasswd",
          "ViewPasswd",
        ];
        this.flagInstruct = arr.some((name) => {
          return obj1.resources.some(
            (item) => item.name === name && item.selected
          );
        });
      }
    },
    toggleChage() {
      this.$router.push({ name: "CabinetList" });
    },

    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.cabinetModelList = getModelData();
      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
      }

      let companyId = _this.$route.query.companyId || ""; //获取ID

      if (companyId) {
        _this.companyId = companyId;
      }
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/cabinet/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.keyword.length > 0) {
        sendUrl += "&cabinetCodeLike=" + encodeURI(_this.keyword);
      }

      if (_this.companyId.length > 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.modelId.length > 0) {
        sendUrl += "&modelId=" + _this.modelId;
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;

          for (var i = 0; i < _this.listData.length; i++) {
            if (_this.listData[i].online == 0) {
              _this.listData[i].state = 1;
            }
          }
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //显示发指令窗口
    deliveryDialogOpen: function (val) {
      let _this = this;
      _this.cabinetCode = val.cabinetCode;
      //加载费率列表
      AxiosAjax({
        url:
          "/cabinet/feeConfig/page?index=1&size=100&companyId=" + val.companyId,
        success: function (res) {
          _this.FeeConfigList = res.data.data.content;
        },
      });

      _this.showDeliveryDialog = true;
    },

    showPasswd: function () {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }

      //查询密码
      AxiosAjax({
        url:
          "/cabinet/cabinet/passwd/" +
          _this.cabinetCode +
          "?userType=" +
          _this.cabinetPasswd.userType,
        loading: true,
        success: function (res) {
          console.log(res.data.data);

          if (res.data.data.code == "000000") {
            _this.cabinetPasswd.oldPasswd = res.data.data.data;
          }

          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    setPasswd: function () {
      let _this = this;

      var _model = {
        cabinetCode: _this.cabinetCode,
        userType: _this.cabinetPasswd.userType,
        newPasswd: _this.cabinetPasswd.newPasswd,
        oldPasswd: "",
      };

      if (
        _this.cabinetPasswd.newPasswd.length > 8 ||
        _this.cabinetPasswd.newPasswd.length < 6
      ) {
        _this.$message({
          type: "warning",
          message: "6-8位数字密码",
        });

        return;
      }

      //设置密码
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/setPasswd",
        data: _model,
        loading: true,
        successMsg: "指令已发送",
        success: function (res) {
          console.log(res.data.data.msg);

          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    setUpdate: function () {
      let _this = this;

      _this.cabinetUpdate.downUrl =
        "http://ms.fuxinsz.com/Package/FuXinEnergy_" +
        _this.cabinetUpdate.softVer +
        ".zip";

      var _model = {
        cabinetCode: _this.cabinetCode,
        force: 0,
        downUrl: _this.cabinetUpdate.downUrl,
        softVer: _this.cabinetUpdate.softVer,
        md5: "",
      };

      if (_this.cabinetUpdate.softVer.length < 3) {
        _this.$message({
          type: "warning",
          message: "请输入版本号",
        });

        return;
      }

      if (_this.cabinetUpdate.downUrl.length < 10) {
        _this.$message({
          type: "warning",
          message: "下载地址不能为空",
        });

        return;
      }

      if (_this.cabinetUpdate.downUrl.indexOf("http") == -1) {
        _this.$message({
          type: "warning",
          message: "请输入正确的下载地址",
        });

        return;
      }

      //设置密码
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/updateSoft",
        data: _model,
        loading: true,
        successMsg: "指令已发送",
        success: function (res) {
          console.log(res.data.data.msg);

          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    showFeeConfig: function () {
      //查询费率
      let _this = this;

      _this.showFee = false;

      AxiosAjax({
        method: "get",
        url: "/cabinet/cabinet/feeConfig/" + _this.cabinetCode,
        loading: true,
        success: function (res) {
          console.log(res.data.data);

          if (res.data.data.code == "000000") {
            _this.showFee = true;
            _this.feeModel = res.data.data.data;
          }

          _this.$message({
            type: "warning",
            message: res.data.data.msg,
          });
        },
      });
    },
    setFeeConfig: function () {
      //设置费率

      let _this = this;
      _this.showFee = false;

      var dataMode = {
        cabinetCodes: [_this.cabinetCode],
        effectiveTime: _this.delivery.effectiveTime,
        feeConfigId: _this.delivery.feeConfigId,
        topPeakMonths: [],
      };

      if (_this.delivery.topPeakMonths.length > 0) {
        dataMode.topPeakMonths = _this.delivery.topPeakMonths.split(",");
      }

      //下发费率
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/feeConfigIssue",
        data: dataMode,
        loading: true,
        success: function (res) {
          console.log(res.data.data.msg);

          if (res.data.code == "000000") {
            console.log(res.data.data.msg);
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },
    setWorkState: function () {
      //设置费率
      let _this = this;

      var dataMode = {
        cabinetCode: _this.cabinetCode,
        state: _this.workStateControl.state,
      };

      //下发费率
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/workStateControl",
        data: dataMode,
        loading: true,
        success: function (res) {
          console.log(res.data.data.msg);

          if (res.data.code == "000000") {
            console.log(res.data.data.msg);
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },
    addLinkUrl: function (url) {
      this.$router.push({ name: "CabinetCabinetEdit" });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "CabinetCabinetEdit", query: { id: url } });
    },
    //跳转链接
    cabinetShow: function (item) {
      // this.cabinetId = val;
      this.$router.push({
        name: "CabinetDetails",
        query: {
          id: item.id,
          companyId: item.companyId,
          cabinetCodes: item.cabinetCode,
        },
      });
      // this.$router.push({name: 'CabinetShow', query: {id: this.cabinetId}})
    },
    //单项删除
    deleteItem: function (val) {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/cabinet/" + val,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
    //切换更多查询条件
    toggleToolsBar: function () {
      this.showToolsBar = !this.showToolsBar;
      if (this.showToolsBar) {
        this.heightToolsBar = "height:auto";
        this.iconToolsBar = "iconfont icon-d-arrow-up";
      } else {
        this.heightToolsBar = "height:60px";
        this.iconToolsBar = "iconfont icon-d-arrow-down";
      }
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
    this.initData();
  },
};
</script>
<style scoped>
.toolbar-box .more-box {
  justify-content: flex-start;
}

.toolbar-box .more-box dl {
  margin-right: 10px;
}

.interval-box {
  width: 120px;
  display: inline-block;
  margin: 0px 10px;
}
.dl-box-fee div {
  height: 35px;
  line-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cabinet/CabinetList.vue